
let defauleWeight = [2,2,2,2]
let userData = JSON.parse(localStorage.getItem('userData'))
if(userData&&userData.weight&&userData.weight.length){
    defauleWeight= [...userData.weight]
}

let serviceObj = [
    {
        name: 'ResearchGate Marketing',
        subtitle:'Academic Research Oriented',
        mark:'This is only an estimated number of impressions—actual visibility on ResearchGate may vary depending on your audience’s activity, publication relevance, and the platform’s algorithm.',
        mark2:'An "impression" refers to the number of times an advertisement or piece of content is displayed to a user, regardless of whether they click on it or engage with it.',
        picObj:['service001.jpeg'],
        basicVlaue:[90,180,540,900,1900],
        numArr1:[],
        numArr2:[],
        numArr3:[],
        numArr4:[],
        numArr5:[],
        maxNum:5700,
        totalNumArr:[],
        currentData:90, //当前基准数
        currentMaxData:720, //当前基准数的最大数
        numberOfPices:66.6, //占比
        currentNum:180, // 默认当前基本数的2倍
        perNum:defauleWeight[0],
    },
    {
        name: 'Linkedin Marketing',
        subtitle:'Industry Research Oriented',
        mark:'This is only an estimated number of impressions—the actual reach will depend on factors such as bidding price, research field, number of active users, and competition from other advertisers.',
        mark2:'An "impression" refers to the number of times an advertisement or piece of content is displayed to a user, regardless of whether they click on it or engage with it.',
        picObj:['service002.jpeg'],
        basicVlaue:[60,120,360,600,1200],
        numArr1:[],
        numArr2:[],
        numArr3:[],
        numArr4:[],
        numArr5:[],
        maxNum:9600,
        totalNumArr:[],
        currentData:60,
        currentMaxData:480, //当前基准数的最大数
        numberOfPices:66.6,
        currentNum:120, // 默认当前基本数的2倍
        perNum:defauleWeight[1],

    },
    {
        name: 'Researchers Email Outreach',
        subtitle:'Expanding Direct Networking and Opportunities',
        mark:'This is only an estimated number of impressions—the actual count depends on how many relevant and active researchers we identify in our database. It also varies based on the thresholds you set on the settings page—stricter relevance filters will reduce the target audience. Additional factors such as selected regions, countries, institutions, and any applied blacklists will also influence the final reach.',
        mark2:'An "impression" refers to the number of times an advertisement or piece of content is displayed to a user, regardless of whether they click on it or engage with it.',
        picObj:['service003.jpeg'],
        basicVlaue:[5,10,30,50,100],
        numArr1:[],
        numArr2:[],
        numArr3:[],
        numArr4:[],
        numArr5:[],
        maxNum:300,
        totalNumArr:[],
        currentData:5,
        currentMaxData:40, //当前基准数的最大数
        numberOfPices:66.6,
        currentNum:10, // 默认当前基本数的2倍
        perNum:defauleWeight[2],

    },
    {
        name: 'LLM Reply Marketing',
        subtitle:'Boosting Visibility and Potential via AI',
        mark:'This figure represents an estimate—real exposure from LLM-generated replies will vary depending on prompt quality, platform traffic, and conversation relevance.',
        mark2:'An "impression" refers to the number of times an advertisement or piece of content is displayed to a user, regardless of whether they click on it or engage with it.',
        picObj:['service004.jpeg','service005.jpeg'],
        basicVlaue:[2,4,12,20,40],
        numArr1:[],
        numArr2:[],
        numArr3:[],
        numArr4:[],
        numArr5:[],
        maxNum:320,
        totalNumArr:[],
        currentData:2,
        currentMaxData:16, //当前基准数的最大数
        numberOfPices:66.6,
        currentNum:4, // 默认当前基本数的2倍
        perNum:defauleWeight[3],

    },
   
]

for(let i in serviceObj){
    let item = serviceObj[i].basicVlaue
    let arr = [0,1,2,3,4,5,6,7,8,3.5]
    for(let j=0;j<10;j++){
        serviceObj[i].numArr1[j]=Math.ceil(item[0]*arr[j]) 
        serviceObj[i].numArr2[j]=Math.ceil(item[1]*arr[j])
        serviceObj[i].numArr3[j]=Math.ceil(item[2]*arr[j])
        serviceObj[i].numArr4[j]=Math.ceil(item[3]*arr[j])
        serviceObj[i].numArr5[j]=Math.ceil(item[4]*arr[j])
    }
    // 使用concat合并数组，然后用filter去重
    serviceObj[i].totalNumArr = serviceObj[i].numArr1.concat(serviceObj[i].numArr2,serviceObj[i].numArr3,serviceObj[i].numArr4,serviceObj[i].numArr5).filter((item, index, self) => {
        return self.indexOf(item) === index;
    });
    
    // 对数组进行排序
    serviceObj[i].totalNumArr.sort((a, b) => a - b);
    serviceObj[i].totalNumArr = serviceObj[i].totalNumArr.filter((value)=>{
        return  value <= serviceObj[i].maxNum
    })
}

export const emailServiceName= ['Basic Plan','Basic ++ Plan', 'Standard Plan', 'Standard ++ Plan', 'Pro Plan']
export const serviceData =  serviceObj